/**
 * Error messages that are not thrown by application code. They arrive via the
 * global `onunhandledrejection` handler with no usable stack trace, so they are
 * non-actionable noise that inflates the production error rate. We drop them at
 * the Sentry client via `ignoreErrors`.
 *
 * See Linear BADGE-5962 and Sentry issues DASHBOARD-WEB-ES, DASHBOARD-WEB-2GD.
 */
export const sentryIgnoredErrors: (string | RegExp)[] = [
  // Injected by a browser extension (commonly seen on Windows/Chrome). The id,
  // method name and param count vary, so match the shape rather than a literal.
  /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/,
  // "user rejected the request" never appears in our source and arrives with no
  // stack trace, so it originates outside application code (a browser extension
  // or injected third-party script). Match case-insensitively as the casing of
  // the phrase varies by source.
  /user rejected the request/i
]
